// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const AlertSuccess: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
            <path
                fill="currentColor"
                d="M9,18 C13.9705692,18 18,13.9705692 18,9 C18,4.02943076 13.9705692,0 9,0 C4.02943076,0 0,4.02943076 0,9 C0,13.9705692 4.02943076,18 9,18 Z M7.13778194,13.7654084 L3.36358839,9.99121488 C3.1368802,9.76447124 3.1368802,9.39678364 3.36358839,9.17004001 L4.18476326,8.34890058 C4.4115069,8.12215694 4.77919449,8.12215694 5.00593813,8.34890058 L7.5483871,10.891385 L12.9940619,5.44571021 C13.2208409,5.21893114 13.5885285,5.21893114 13.8152367,5.44571021 L14.6364116,6.26684964 C14.8631198,6.49359328 14.8631198,6.86128087 14.6364116,7.08802451 L7.95899225,13.7654439 C7.73221317,13.9921521 7.36456102,13.9921521 7.13778194,13.7654084 Z"
            />
        </svg>
    );
};

export default React.memo(AlertSuccess);
